import * as React from "react";
const CloseModal = (props) => (
    <svg
      width={34}
      height={33}
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity={0.1}
        d="M17.1966 3.53125C9.71512 3.53125 3.6283 9.36312 3.6283 16.5312C3.6283 23.6994 9.71512 29.5312 17.1966 29.5312C24.6781 29.5312 30.7649 23.6994 30.7649 16.5312C30.7649 9.36312 24.6781 3.53125 17.1966 3.53125Z"
        fill="#C4C4C4"
      />
      <path
        d="M21.3715 12.5312L13.0217 20.5313"
        stroke="#C4C4C4"
        strokeLinecap="round"
      />
      <path
        d="M21.3715 20.5312L13.0217 12.5312"
        stroke="#C4C4C4"
        strokeLinecap="round"
      />
    </svg>
);
export default CloseModal;
